export enum CustomerType {
  IndividualPerson = 0,
  LegalEntity = 1
};
